<template>
  <v-container>
    <h2>Wholesales products Brandclub Wholesale store</h2>
    <div class="mt-12">
      <v-alert text dense color="deep-orange" icon="mdi-text-search" border="left">
        In order to see products, you need to add conditions to filter, then
        press <strong>Filter products</strong> button. If you want to see all
        products, just press <strong>Filter products</strong> button without any
        conditions added.
      </v-alert>
      <v-alert text dense color="deep-orange" icon="mdi-text-search" border="left">
        To view brands that have product mixes, please use the checkbox "Show only brands that have WH MIX products"
        after filtering.
      </v-alert>
    </div>
    <div class="mt-12">
      <FilterForm @formatValues="formatFilterValues" :showButtons="true" ref="filterComponent"
        :isWholeSalesProps="true"></FilterForm>
    </div>
    <div class="d-flex flex-row-reverse">
      <v-btn class="btn_add_pr" color="success" @click="OpenCreateModal">Add Product</v-btn>
      <v-btn v-if="selectedProducts.length > 0" class="btn_add_pr" color="success" @click="ExportProduct">Export
        Products</v-btn>
    </div>
    <v-snackbar v-model="snackbarEmpty">
      {{ errorEmpty }}
    </v-snackbar>
    <v-row v-if="fetched">
      <v-col>
        <v-checkbox v-model="OnlyMissing" :label="`Show products that has missing information. `"></v-checkbox>
      </v-col>
      <v-col>
        <v-checkbox v-model="OnlyBrandsWithMixes" :label="`Show only brands that have WH MIX products`"></v-checkbox>
      </v-col>
      <v-col>
        <v-select :items="['NOT EXPORTED', 'draft', 'publish', 'clear']" label="Filter by status"
          v-model="filterBy"></v-select>
      </v-col>
    </v-row>

    <!-- Brand Mix Summary Card -->
    <v-card v-if="fetched && brandsWithMixes.length > 0" class="mb-4" outlined>
      <v-card-title class="subtitle-2">
        <v-icon color="orange" class="mr-2">mdi-package-variant</v-icon>
        Brands with MIX Products ({{ brandsWithMixes.length }})
      </v-card-title>
      <v-card-text>
        <v-chip-group>
          <v-chip v-for="brand in brandsWithMixes" :key="brand.name" small color="orange" outlined
            @click="filterByBrand(brand.name)" class="ma-1">
            <v-icon left small>mdi-package-variant</v-icon>
            {{ brand.name }} ({{ brand.mixCount }} mixes)
          </v-chip>
        </v-chip-group>
        <div class="caption grey--text mt-2">
          Click on a brand chip to filter products by that brand
        </div>
      </v-card-text>
    </v-card>

    <v-divider class="my-2"></v-divider>
    <v-row>
      <v-col>
        <v-data-table class="mt-6" v-model="selectedProducts" :headers="headers" :items="items" show-select
          item-key="SKU" :single-expand="true" :expanded.sync="expanded" show-expand :search="search" dense
          height="65vh" fixed-header :footer-props="{
            'items-per-page-options': [50, 100, 150, 200],
          }">
          <template v-slot:[`item.Photos`]="{ item }">
            <v-img max-width="100px" :src="item.FeaturedImage"></v-img>
          </template>
          <template v-slot:[`item.Status`]="{ item }">
            <v-chip small :color="item.Status == 'publish'
              ? 'green'
              : item.Status == 'NOT EXPORTED'
                ? 'lightgray'
                : 'grey'
              " dark>
              {{ item.Status }}
            </v-chip>
          </template>
          <template v-slot:[`item.SKU`]="{ item }">
            <tr>
              <td>
                <span class="font-weight-medium">{{ item.SKU }}</span><br />
                <span v-if="item.BarCode" class="grey--text">
                  BAR: {{ item.BarCode }}
                </span>
                <!-- Mix indicator for individual products -->
                <br v-if="item.ProductType === 'WH MIX'">
                <v-chip v-if="item.ProductType === 'WH MIX'" x-small color="orange" text-color="white" class="mt-1">
                  <v-icon x-small left>mdi-package-variant</v-icon>
                  MIX
                </v-chip>
              </td>
            </tr>
          </template>
          <template v-slot:[`item.Brand`]="{ item }">
            <tr>
              <td>
                <div class="d-flex align-center">
                  <div>
                    <span>{{ item.Brand }}</span>
                    <!-- Brand mix indicator -->
                    <v-icon v-if="isBrandWithMixes(item.Brand)" small color="orange" class="ml-1"
                      :title="`${item.Brand} has ${getBrandMixCount(item.Brand)} MIX products`">
                      mdi-package-variant
                    </v-icon>
                    <br />
                    <span class="grey--text"> {{ item.BrandName }} </span>
                  </div>
                </div>
              </td>
            </tr>
          </template>
          <template v-slot:[`item.Quantity`]="{ item }">
            <v-chip small :color="item.Quantity < 1 ? 'grey' : 'green'" dark>
              {{ item.Quantity }}
            </v-chip>
          </template>
          <template class="action_btn" v-slot:[`item.ACTIONS`]="{ item }">
            <div class="action_btn">
              <v-btn color="primary" @click="UpdateProduct(item)">Update</v-btn>
              <v-btn color="primary" @click="ShowPrintModal(item)">Copy</v-btn>
            </div>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <ProductInfo :product="item"></ProductInfo>
            </td>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-dialog persistent v-model="showCopyModal" width="650px">
      <v-card>
        <v-form ref="form" lazy-validation @input="formToggled">
          <v-card-title class="subtitle-1 grey accent" primary-title>
            <span class="text-h5">Create a copy from : {{ currentSKU }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-spacer></v-spacer>
              <v-row><v-col></v-col></v-row>
              <v-row>
                <v-col>
                  <v-text-field color="accent" label="Min order" v-model="minOrder" type="number" outlined dense
                    clearable :rules="[rules.required, rules.prices]" @wheel="$event.target.blur()">
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-expansion-panels class="margin">
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      Locations
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <div v-for="(item, i) in copyLocations" :key="i" class="borderd">
                        <v-row>
                          <v-col>
                            <v-text-field color="accent" label="Location" v-model="copyLocations[i].location"
                              type="text" outlined dense clearable :rules="[rules.required]"
                              @wheel="$event.target.blur()">
                            </v-text-field>
                          </v-col>
                          <v-col>
                            <v-text-field color="accent" label="Quantity" v-model="copyLocations[i].quantity"
                              type="text" outlined dense clearable :rules="[rules.required]"
                              @wheel="$event.target.blur()">
                            </v-text-field>
                          </v-col>
                          <v-col cols="1" class="mt-1">
                            <v-icon class="ml-4" size="30" color="error" cursor="pointer"
                              @click="removeField(i, 'location')">mdi-close-thick</v-icon>
                          </v-col>
                        </v-row>
                      </div>
                      <v-btn @click="AddNewLocation"> Add location </v-btn>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDialog">
              Close
            </v-btn>
            <v-btn color="blue darken-1" text @click="createACopy">
              Save
            </v-btn>
          </v-card-actions>
        </v-form></v-card>
    </v-dialog>
    <v-dialog persistent v-model="ShowUpdatingStatus" width="unset">
      <status-info :responseMessage="responseMessage" :filename="filename" :pending="pending" @close="closeStatuDialog"
        :showCheckBtn="false"></status-info>
    </v-dialog>
    <CreateWHProduct v-if="OpenCreate" :close="CloseModal"></CreateWHProduct>
    <UpdateWHProduct v-if="currentProduct" :oldProduct="currentProduct" :close="CloseModal"
      :formatFilterValues="ResendFilter"></UpdateWHProduct>
    <v-snackbar top v-model="snackbar" color="#FF3232" class="white--text">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import FilterForm from "@/components/organisms/FilterForm.vue";
import CreateWHProduct from "../modals/createWHProduct.vue";
import ProductInfo from "../organisms/ProductInfo.vue";
import UpdateWHProduct from "../modals/UpdateWHProduct.vue";
// import ProductHistoryDialog from "../Descriptions/ProductHistoryDialog.vue";
import StatusInfo from "../organisms/StatusInfo";
import axios from "axios";

export default {
  name: "WholeSalesContent",
  props: {},
  components: {
    StatusInfo,
    FilterForm,
    ProductInfo,
    CreateWHProduct,
    UpdateWHProduct,
  },
  data: () => ({
    snackbarEmpty: false,
    errorEmpty: `Please select products to export.`,
    selectedProducts: [],
    minOrder: null,
    showCopyModal: false,
    OnlyMissing: false,
    OnlyBrandsWithMixes: false, // Filter for brands with mixes
    PrintModule: "sku",
    headers: [
      { text: "TITLE", value: "Title", class: "footer" },
      { text: "PHOTO", value: "Photos", class: "footer" },
      { text: "STATUS", value: "Status", class: "footer" },
      { text: "SKU", value: "SKU", class: "footer" },
      { text: "BARCODE", value: "BarCode", class: "footer" },
      { text: "CATEGORY", value: "Category", class: "footer" },
      { text: "PRICE", value: "Price", class: "footer" },
      { text: "BRAND", value: "Brand", class: "footer" },
      { text: "STOCK", value: "Quantity", class: "footer" },
      { text: "ACTIONS", value: "ACTIONS", class: "footer" },
    ],
    items: [],
    MainProducts: [], // Store all products before filtering
    copyLocations: [
      {
        location: null,
        quantity: null,
      },
    ],
    currentSKU: "",
    expanded: [],
    search: "",
    loadingFilter: false,
    fileName: "",
    OpenCreate: false,
    productForHistory: {},
    ShowUpdatingStatus: false,
    filename: "",
    pending: false,
    responseMessage: "",
    currentProduct: null,
    itemToPrint: null,
    Filters: [],
    filterBy: null,
    ShowTranslationModal: false,
    fetched: false,
    translations: [],
    snackbarText: "",
    snackbar: false,
    brandsWithMixes: [], // Store brands that have mix products
    rules: {
      required: (value) => !!value || "please fill up the input",
      prices: (value) => {
        if (value <= 0 || isNaN(value) || value.length < 1) {
          return "Must be more than 0 !";
        } else {
          return true;
        }
      },
    },
  }),
  watch: {
    items(val) {
      if (val.length == 0) {
        this.loadingFilter;
      }
    },
    PrintModule(val) {
      if (val == "sku") {
        this.currentSKU = this.itemToPrint.SKU;
      } else {
        this.currentSKU = this.itemToPrint.BarCode;
      }
    },
    filterBy() {
      this.applyFilters();
    },
    OnlyMissing() {
      this.applyFilters();
    },
    OnlyBrandsWithMixes() {
      this.applyFilters();
    },
    AddNewLocation() {
      this.copyLocations.push({ location: null, quantity: null });
    },
  },
  async mounted() {
    const editId = this.$route?.query?.edit;
    if (editId) {
      await this.openProductById(editId);
    }
  },
  methods: {
    // Check if a brand has mix products
    isBrandWithMixes(brandName) {
      return this.brandsWithMixes.some(brand => brand.name === brandName);
    },
    async openProductById(id) {
      this.ShowUpdatingStatus = true;
      this.pending = true;
      this.responseMessage = "Loading product...";

      try {
        // Fetch the single product directly by its Firestore ID
        const response = await axios.get(`/api/WHProduct/get-by-id/${id}`);
        this.pending = false;
        this.ShowUpdatingStatus = false;
        this.currentProduct = response.data;
      } catch (error) {
        this.pending = false;
        this.ShowUpdatingStatus = false;
        this.snackbarText = "Could not load product from link.";
        this.snackbar = true;
      }
    },
    // Get the count of mix products for a brand
    getBrandMixCount(brandName) {
      const brand = this.brandsWithMixes.find(brand => brand.name === brandName);
      return brand ? brand.mixCount : 0;
    },

    // Filter products by specific brand
    filterByBrand(brandName) {
      this.search = brandName;
    },

    // Update brands with mixes summary
    updateBrandsWithMixes() {
      if (!this.MainProducts || this.MainProducts.length === 0) {
        this.brandsWithMixes = [];
        return;
      }

      const brandCounts = {};
      this.MainProducts.forEach(product => {
        if (product.ProductType === 'WH MIX') {
          const brandName = product.Brand;
          if (brandCounts[brandName]) {
            brandCounts[brandName]++;
          } else {
            brandCounts[brandName] = 1;
          }
        }
      });

      this.brandsWithMixes = Object.keys(brandCounts).map(brand => ({
        name: brand,
        mixCount: brandCounts[brand]
      })).sort((a, b) => b.mixCount - a.mixCount);

      console.log('Updated brands with mixes:', this.brandsWithMixes);
    },

    // Apply all filters consistently
    applyFilters() {
      if (!this.MainProducts || this.MainProducts.length === 0) {
        console.log('MainProducts not available yet');
        this.items = [];
        return;
      }

      console.log('Applying filters...', {
        OnlyMissing: this.OnlyMissing,
        OnlyBrandsWithMixes: this.OnlyBrandsWithMixes,
        filterBy: this.filterBy,
        totalProducts: this.MainProducts.length
      });

      let filteredItems = [...this.MainProducts];

      // Apply status filter
      if (this.filterBy && this.filterBy !== "clear") {
        filteredItems = filteredItems.filter((i) => i.Status === this.filterBy);
        console.log('After status filter:', filteredItems.length);
      }

      // Apply missing information filter
      if (this.OnlyMissing) {
        filteredItems = filteredItems.filter((i) => {
          return (
            !i.Description ||
            !i.Images ||
            !i.Images.length ||
            !i.FeaturedImage ||
            !i.Price
          );
        });
        console.log('After missing info filter:', filteredItems.length);
      }

      // Apply brands with mixes filter
      if (this.OnlyBrandsWithMixes) {
        // Calculate brands with mixes directly from MainProducts
        const brandsWithMixNames = new Set();
        this.MainProducts.forEach(product => {
          if (product.ProductType === 'WH MIX') {
            brandsWithMixNames.add(product.Brand);
          }
        });

        console.log('Brands with mixes:', Array.from(brandsWithMixNames));

        // Filter to show only products from brands that have at least one WH MIX product
        filteredItems = filteredItems.filter((product) =>
          brandsWithMixNames.has(product.Brand)
        );
        console.log('After brands with mixes filter:', filteredItems.length);
      }

      console.log('Final filtered items:', filteredItems.length);
      this.items = filteredItems;
    },

    closeDialog() {
      this.showCopyModal = false;
      this.ShowTranslationModal = false;
    },

    CloseModal() {
      this.OpenCreate = false;
      this.currentProduct = null;
      this.filterProducts(this.Filters);
    },

    async OpenCreateModal() {
      this.OpenCreate = true;
      console.log(this.OpenCreate);
    },

    async UpdateProduct(item) {
      console.log("this is the product ==> ", JSON.stringify(item));
      this.currentProduct = item;
    },

    async ShowPrintModal(item) {
      console.log(item);
      this.showCopyModal = true;
      this.currentSKU = item.SKU;
      this.itemToPrint = item;
    },

    async createACopy() {
      var mainProduct = this.items.find((p) => p.SKU == this.currentSKU);
      if (mainProduct.MinOrder == this.minOrder) {
        this.snackbar = true;
        this.snackbarText = "This product already exist !";
        return;
      }
      this.showCopyModal = false;
      this.ShowUpdatingStatus = true;
      this.pending = true;
      this.responseMessage = "Loading !";
      await axios
        .post("/api/WHProduct/copy-whProduct", {
          sku: this.currentSKU,
          minOrder: this.minOrder,
          locations: this.copyLocations,
        })
        .then(() => {
          this.pending = false;
          this.filename = "high_five.svg";
          this.responseMessage = "Product has been created successfully !";
          this.ResendFilter()
        })
        .catch((err) => {
          this.pending = false;
          this.filename = "server_down.svg";
          this.responseMessage = err.response.data;
        });
    },

    ResendFilter() {
      this.filterProducts(this.Filters);
    },

    formatFilterValues(filters) {
      this.items = [];
      let finalData = [];
      let val = "";
      this.$refs.filterComponent.setLoading(true);
      if (filters.length > 0) {
        for (let obj of filters) {
          if (obj.condition == "Yes") {
            val = true;
          } else if (obj.condition == "No") {
            val = false;
          } else if (obj.property["type"] === "Number") {
            val = parseInt(obj.value);
          } else if (obj.property["type"] === "Array") {
            // arr.push(obj.value)
            val = obj.value;
          } else {
            val = obj.value;
          }
          finalData.push([obj.property["name"], obj.condition, val]);
        }
      }
      this.Filters = finalData;
      this.filterProducts(finalData);
    },

    closeStatuDialog() {
      this.ShowUpdatingStatus = false;
    },

    vaildateHasDescription() {
      var isValid = true;
      for (var i = 0; i < this.translations; i++) {
        if (!this.translations[i]["Description-LT"]) {
          isValid = false;
          break;
        }
      }
      return isValid;
    },

    ExportProduct() {
      // console.log(this.$refs.translations.validate());
      // if (
      //   !this.$refs.translations.validate() ||
      //   this.vaildateHasDescription()
      // ) {
      //   this.snackbarText = "The form is filled incorretly!";
      //   this.snackbar = true;
      //   return;
      // }
      var ids = this.selectedProducts.map((p) => p.id);
      console.log(ids);
      this.ShowUpdatingStatus = true;
      this.pending = true;
      this.responseMessage = "Loading !";
      this.$store
        .dispatch("ExportWHProduct", {
          ids: ids,
          translations: this.translations,
        })
        .then(() => {
          this.pending = false;
          this.ShowUpdatingStatus = true;
          this.filename = "high_five.svg";
          this.responseMessage = "All the products has been exported !";
        })
        .catch((error) => {
          this.pending = false;
          this.ShowUpdatingStatus = true;
          this.filename = "server_down.svg";
          this.responseMessage = error.response?.data;
        });
    },

    filterProducts(data) {
      console.log("this is filter products => ", JSON.stringify(data));
      this.$store
        .dispatch("getProductsWholeSales", data)
        .then((response) => {
          // Store the original data first
          this.MainProducts = response.data;
          this.selectedProducts = [];

          // Update brands with mixes first
          this.updateBrandsWithMixes();

          // Then apply all filters
          this.applyFilters();

          if (response.data.length < 1) {
            let errorMsg = "Empty data !";
            this.$refs.filterComponent.setLoadingFailed(true, errorMsg);
          } else {
            this.$refs.filterComponent.setLoading(false);
            this.fetched = true;
          }
        })
        .catch((error) => {
          this.$refs.filterComponent.setLoading(false);
          let errorMsg = error.response.data ? error.response.data : "Something went wrong while filtering.";
          this.$refs.filterComponent.setLoadingFailed(true, errorMsg);
          console.log(error);
        });
    },
  },
};
</script>

<style>
.update_button {
  display: flex;
  justify-content: flex-end;
}

.update_btn {
  margin: 1em;
}

.price-item {
  padding-bottom: 1em;
  border-bottom: 1px solid lightgray;
}

.alert_price {
  display: flex !important;
  align-items: center !important;
}

.buttons {
  display: flex;
  justify-content: center;
  align-items: center;
}

.action_btn {
  display: flex;
  gap: 15px;
}

.btn_add_pr {
  margin: 1em;
}
</style>